<template>
    <div>
        <stream-item 
            @select="menuItemSelected" 
            :class="itemClasses" 
            :menu-options="menuOptions" 
            :icon="iconName" 
            line-type="dashed"
        >
            <div class="activity-stream-item">
                <ui-checkbox 
                    v-model='done' 
                    :trueValue="true" 
                    :falseValue="false" 
                    @input="toggleActivity"
                />
                <a 
                    href="#" 
                    @click.prevent="menuItemSelected({ id: 'edit' })" 
                    class="activity-stream-item-title"
                >{{ data.title }}</a>
                <div class="activity-stream-item-notes" v-if="data.notes">
                    {{ data.notes }}
                </div>
            </div>
            <stream-item-header 
                :created-by="data.created_by" 
                :created-at="data.due_at" 
                position="bottom"
            />
        </stream-item>

        <activity-modal 
            v-if="editorEnabled"
            ref="editor"
            @saved="$emit('updated')"
        />
    </div>
</template>

<style lang="scss">

    .activity-stream-item-overdue {
        .card { 
            background: repeating-linear-gradient(50deg, #f9ecee, #f9ecee 10px, #fff 10px, #fff 20px);
            color: #dc3545;
            a { color: #dc3545; }
        }

        .ui-checkbox {
            .ui-checkbox__checkmark-background { border-color: #f44336; }
        }
    }

    .activity-stream-item {
        padding: 1rem 1.5rem 0;

        .activity-stream-item-title {
            margin-left: .75rem;
            line-height: normal;
            vertical-align: middle;
            color: #42526e;
        }

        .activity-stream-item-notes {
            margin: 1rem 0 .5rem 0;
        }

        .ui-checkbox {
            display: inline-block;
            margin-bottom: 0;
            vertical-align: middle;

            &:not(.is-disabled).is-checked:hover .ui-checkbox__checkmark-background, 
            &:not(.is-disabled).is-checked.is-active .ui-checkbox__checkmark-background,
            &.is-checked .ui-checkbox__checkmark-background {
                background: #4caf50;
                border-color: #4caf50;
            }
        }
    }
</style>

<script>
    import Moment from 'moment'
    import StreamItemHeader from './StreamItemHeader'
    import StreamItem from './StreamItem'
    import ActivityModal from '../../ActivityModal'
    import { ActivityMediumsListItemRetriever, ActivityResource } from '../../../classes/Api/Activity'
    import deleteActivity from "../../activity/ActivityDeletionLogic";

    const menuOptions = [
        {
            id: 'edit',
            icon: 'edit',
            label: 'Edit'
        },
        {
            id: 'delete',
            icon: 'delete',
            label: 'Delete'
        },
    ]

    export default {
        components: { 
            StreamItemHeader, 
            StreamItem,
            ActivityModal
        },
        props: {
            data: {
                type: Object,
                required: true
            }
        },
        created() {
            this.done = this.data.completed_at ? true : false
        },
        data() {
            return {
                menuOptions,
                done: false,
                editorEnabled: false,
            }
        },
        methods: {
            toggleActivity: _.debounce(function(e) {
                if (this.done && !this.data.completed_at) {
                    ActivityResource.complete(this.data.id).then(r => {
                        this.editorEnabled = true

                        this.$nextTick(() => {
                            this.$refs.editor.$refs.activityPane.updateActivity({
                                lead: r.data.lead,
                                lead_id: r.data.lead_id,
                                owner: r.data.owner,
                                owner_id: r.data.owner_id,
                                contact: r.data.contact,
                                contact_id: r.data.contact_id,
                            })

                            this.$refs.editor.open();
                        })

                        this.$emit('updated', r.data)
                    }).catch(handleApiError)
                } else if (!this.done && this.data.completed_at) {
                    ActivityResource.uncomplete(this.data.id).then(r => {
                        this.$emit('updated', r.data)
                    }).catch(handleApiError)
                }
            }, 100),
            menuItemSelected(e) {
                switch (e.id) {
                    case 'delete':
                        if (confirm('Are you sure you want to delete this activity?')) {
                            deleteActivity(this.data).then(() => {
                                this.$emit('deleted');
                            })
                        }
                    break;
                    case 'edit':
                        this.editorEnabled = true
                        this.$nextTick(() => {
                            this.$refs.editor.open(this.data.id)
                        })
                    break;
                }
            }
        },
        computed: {
            iconName() {
                return ActivityMediumsListItemRetriever(this.data.type).icon
            },
            now() {
                return new Date
            },
            itemClasses() {
                return !this.data.completed_at && Moment(this.data.due_at).isBefore(this.now) ? 'activity-stream-item-overdue' : ''
            },
        }
    }
</script>